export default {
  productData: {
    serialNumber: 'DA-HMS-001',
    name: 'Holzbalkendecke mit Schalldämmplatten l Aufbau 1',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: 'ohne',
          value: 'nw-0'
        },
        {
          type: 'soundInsulation',
          title: { de: 'Schalldämmplatte' },
          output: '2 x 15 mm',
          value: 'si-30'
        },
        {
          type: 'insulation',
          title: {
            de:
              'Holzfaserdämmplatte'
          },
          output: '≥ 4',
          value: 'w-4'
        },
        {
          type: 'fill',
          title: {
            de:
              'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 132 kg/m<sup>2</sup>), Rieselschutz'
          },
          output: '≥ 80',
          value: 'scsb-80'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken' },
          output: '240',
          value: 'b-240'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '2 x 120',
          value: 'h-240'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Lattung' },
          output: '24',
          value: 'ba-24'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GKFI' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '413',
        value: 413
      }
    },
    technicalValues: {
      impactSoundLevel: {
        // L,nw
        output: '59 (1; 2)',
        value: 59
      },
      soundReductionIndex: {
        // Rw
        output: '63 (-4; -11)',
        value: 63
      },
      heatTransferCoefficient: {
        // U-Wert
        output: '0,19',
        value: 0.19
      },
      fireResistance: {
        output: '-',
        value: null
      },
      massPerUnitArea: {
        output: '227,4 [kg/m²]'
      }
    }
  },
  image: 'da-hms-001.png',
  pdf: 'Holzbalkendecke-mit-Schalldämmplatten-Aufbau-1-DA-HMS-001-Rev01.pdf'
}
